const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9075"
    },
    d: "M506.126,310.684C509.961,293.063,512,274.771,512,256C512,114.616,397.385,0,256,0 C114.616,0,0,114.616,0,256c0,116.887,78.34,215.473,185.378,246.128L506.126,310.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7452"
    },
    d: "M506.126,310.684l-54.691-54.69H343.522v-77.902L229.03,63.599L67.243,383.993l118.135,118.135 C207.812,508.553,231.503,512,256,512C378.614,512,481.076,425.791,506.126,310.684z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD652"
    },
    points: "343.521,178.091 256.463,178.091 256.463,356.167 451.435,333.909 451.435,255.993  406.913,241.484 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBA4C"
    },
    d: "M431.211,333.909c-13.17-13.706-31.659-22.261-52.124-22.261c-20.464,0-38.954,8.555-52.124,22.261 l-70.502-0.002l33.391,50.087l161.583,0.002v-50.087H431.211z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7EDBC"
    },
    points: "289.841,144.7 289.841,311.645 122.884,333.906 200.799,144.705 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "67.243,144.7 67.243,311.645 178.537,333.906 178.537,144.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "289.852,311.645 67.243,311.645 67.243,333.906 184.113,361.732 289.852,333.905 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.239,
    y: 333.902,
    style: {
      fill: "#B2B2B2"
    },
    width: 222.609,
    height: 50.087
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838"
    },
    d: "M139.597,434.082l-30.052-50.087l30.052-50.087c27.618,0,50.087,22.469,50.087,50.087 C189.684,411.613,167.216,434.082,139.597,434.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M89.51,383.996c0,27.618,22.469,50.087,50.087,50.087V333.907 C111.979,333.909,89.51,356.378,89.51,383.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M139.597,411.822l-16.696-27.826l16.696-27.826c15.343,0,27.826,12.483,27.826,27.826 C167.423,399.339,154.94,411.822,139.597,411.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M111.771,383.996c0,15.343,12.483,27.826,27.826,27.826v-55.652 C124.253,356.169,111.771,368.652,111.771,383.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383838"
    },
    d: "M379.087,434.082l-30.052-50.087l30.052-50.087c27.618,0,50.087,22.469,50.087,50.087 C429.174,411.613,406.705,434.082,379.087,434.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M328.999,383.996c0,27.618,22.469,50.087,50.087,50.087V333.907 C351.468,333.909,328.999,356.378,328.999,383.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M379.087,411.819l-16.696-27.826l16.696-27.826c15.343,0,27.826,12.483,27.826,27.826 C406.913,399.337,394.43,411.819,379.087,411.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M351.261,383.993c0,15.343,12.483,27.826,27.826,27.826v-55.652 C363.744,356.167,351.261,368.65,351.261,383.993z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D33734"
    },
    points: "154.123,105.286 178.885,215.425 206.711,243.251 206.711,105.286 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E24642"
    },
    points: "178.857,105.286 151.059,105.286 151.059,243.251 178.885,215.425 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D33734"
    },
    d: "M186.799,63.242c-5.912,5.912-8.781,13.727-8.626,21.527l-11.382,29.995l11.746,29.995l38.683-21.65 l20.797-37.832c0.099-7.845-2.862-15.753-8.887-21.778C217.371,51.739,198.417,51.624,186.799,63.242z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E24642"
    },
    d: "M259.794,94.163c11.76,11.76,11.875,30.713,0.257,42.332c-5.912,5.912-13.727,8.362-21.525,8.211 h-59.99l59.48-59.429C245.861,85.178,253.773,88.141,259.794,94.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E24642"
    },
    d: "M170.275,63.242c5.912,5.912,8.781,13.727,8.626,21.527l-0.364,59.99l-38.683-21.65l-20.797-37.832 c-0.099-7.845,2.862-15.753,8.887-21.778C139.703,51.739,158.657,51.624,170.275,63.242z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F15D4A"
    },
    d: "M97.279,94.163c-11.76,11.76-11.875,30.713-0.257,42.332c5.912,5.912,13.726,8.362,21.525,8.211 h59.99l-59.48-59.429C111.212,85.178,103.3,88.141,97.279,94.163z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.b5379ce09735a0a97daea4a6b0549da6.svg";
export { ForwardRef as ReactComponent };